import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideClientHydration, withEventReplay, BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { OAuthModule } from 'angular-oauth2-oidc';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SeoService } from './services/seo.service';
import { AnalyticsService } from './services/analytics.service';
import { GlobalService } from './services/global.service';
import { QuoteService } from './services/quote.service';
import { provideEnvironmentNgxMask } from 'ngx-mask';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      FontAwesomeModule,
      FormsModule,
      ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
      OAuthModule.forRoot(),
      LazyLoadImageModule
    ),
    SeoService,
    AnalyticsService,
    GlobalService,
    QuoteService,
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideClientHydration(withEventReplay()),
    provideEnvironmentNgxMask()
  ]
};
